import { store, authActions } from "../_store";
import { history } from "./history";
export const fetchWrapper = {
  get: request("GET"),
  post: request("POST"),
  put: request("PUT"),
  patch: request("PATCH"),
  delete: request("DELETE"),
};

const getBrowserType = () => {
  const userAgent = navigator.userAgent;

  if (userAgent.includes("Firefox")) {
    return "Firefox";
  } else if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
    return "Chrome";
  } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    return "Safari";
  } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
    return "Opera";
  } else if (userAgent.includes("Trident")) {
    return "Internet Explorer";
  } else if (userAgent.includes("Edg")) {
    return "Edge";
  } else {
    return "Unknown";
  }
};

function request(method) {
  return (url, body, options = {}) => {
    const isFormData = body instanceof FormData;
    const headers = {
      ...authHeader(url),
      "X-Client-IP": localStorage.getItem("cachedIP"),
      "X-Client-Browser": getBrowserType(),
      "X-Client-URL": window.location.href,
    };
    const requestOptions = {
      method,
      headers,
      credentials: "include",
    };

    if (body) {
      if (isFormData) {
        // Don't set Content-Type — browser will do it correctly for FormData
        requestOptions.body = body;
      } else {
        requestOptions.headers["Content-Type"] = "application/json";
        requestOptions.body = JSON.stringify(body);
      }
    }

    return fetch(url, requestOptions)
      .then((response) => {
        if (options.isFile) {
          if (!response.ok) {
            throw new Error("Failed to download file");
          }
          return response.blob(); // Return blob directly
        } else {
          return handleResponse(response, method, body); // default JSON logic
        }
      })
      .catch(async (error) => {
        // Re-throw the error after logging
        throw error;
      });
  };
}

// helper functions

// function authHeader(url) {
//   // return auth header with jwt if user is logged in and request is to the api url
//   const token = authToken();
//   const userTokenFromLocalStorage =
//     JSON?.parse(localStorage.getItem("user"))?.Token || "";
//   const isLoggedIn = !!token;
//   const isApiUrl = url.startsWith(process.env.REACT_APP_API_URL);
//   if (isLoggedIn && isApiUrl && userTokenFromLocalStorage !== "") {
//     return { Authorization: `Bearer ${token}` };
//   } else {
//     // const logout = () => store.dispatch(authActions.logout());
//     // logout();
//     // history?.navigate("/login");
//     return {};
//   }
// }
function authHeader(url) {
  return {};
}

function authToken() {
  return null;
}

let isUnauthorizedHandled = false;
function handleResponse(response, method, body) {
  const pathname = window.location.pathname;
  const isLoginApi = response.url.includes("/login"); // we can add multiple routes
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if ([401, 403].includes(response.status) && !isLoginApi) {
        if (!isUnauthorizedHandled) {
          isUnauthorizedHandled = true;

          if (pathname.includes("Admin")) {
            history?.navigate("/Admin/login");
          } else {
            history?.navigate("/login");
          }
          store.dispatch(authActions.logout());
        }
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
